@if (form) {
  <form [formGroup]="form.control" (ngSubmit)="onSubmit()">
    <h1 mat-dialog-title>
      {{ title }} refund option
    </h1>
    <div mat-dialog-content>
      @if (refundInfo$ | async; as refundInfo) {
        <div>
          <ul>
            @if (refundInfo.paid) {
              <li>Amount already paid: {{ refundInfo.paid | currency: refundInfo.currency }}</li>
            }
            @if (refundInfo.paid) {
              <li>Amount to be refunded: {{ refundInfo.toRefund | currency: refundInfo.currency }}</li>
            }
            @if (refundInfo.paid === 0) {
              <li>Payment request to be cancelled: {{ refundInfo.toRefund | currency: refundInfo.currency }}</li>
            }
          </ul>
        </div>
      }
      <eas-easform-group [easGroup]="form">
      </eas-easform-group>
    </div>
    <div mat-dialog-actions>
      <ub-button-list>
        <button mat-flat-button
          type="button"
          color="warn"
        [mat-dialog-close]="canceled">Cancel</button>
        <button mat-flat-button
          type="submit"
          color="primary"
        cdkFocusInitial>{{ title }}</button>
      </ub-button-list>
    </div>
  </form>
}